var ram = "https://shopfront-cdn.tekoapis.com/static/5a9f38ba2258d73d.svg";

export { ram as default };
